import script from "./PasiveFinancial.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasiveFinancial.vue?vue&type=script&setup=true&lang=ts"

import "./PasiveFinancial.vue?vue&type=style&index=0&id=775adfa8&lang=scss"

const __exports__ = script;

export default __exports__